import * as aspSettings from './aspSettings';
import * as settings from '../common/settings';
import { DisplayObject } from './DisplayObject';
import { AspObject } from './AspObject';
import { SensorCoreObject } from './SensorCoreObject';
import { IObjectsDrawer } from './interfaces';
import * as consts from '../common/consts';

export class SensorDisplayCoreObject extends DisplayObject {

  labelVisible: boolean;
  dataChanged: boolean = false;
  color: any;
  opacity: number = 0;
  isHooked: boolean = false;

  wasRemoved: boolean = false;

  constructor(aspObject: AspObject, drawer: IObjectsDrawer) {
    super(aspObject, drawer);

    this.color = aspObject.getColor();
    this.opacity = settings.userSettings.pointOpacity;

    this.drawData[this.aspObject.objectType].colors = [[1, 1, 1, 1], this.color, null, [1, 1, 1, 1], [1, 1, 1, 1]]; // per template
    this.labelVisible = settings.userSettings.pointElementsOn[consts.POINT_DISPLAY_ELEMENT_LABEL];

    this.cluster = {
      dm: drawer.drawMgr,
      typeKey: 'sensorsCluster',
      group: this.aspObject.objectsPool.getObjectType(),
      location: this.geometry as undefined as NeWMI.Pure.Types.Point
    };
  }

  prepareToDraw() {
    let sensorObject = this.aspObject as SensorCoreObject;
    this.cluster.location = this.geometry as undefined as NeWMI.Pure.Types.Point;

    if (sensorObject.isRadar && !settings.userSettings.snsTypeElementsOn[0] ||
      sensorObject.isAcoustic && !settings.userSettings.snsTypeElementsOn[1] ||
      sensorObject.isVideo && !settings.userSettings.snsTypeElementsOn[2]
    ) {
      this.drawer.removeObjectFromDm(this);
      this.wasRemoved = true;
      return;
    }

    if (this.wasRemoved) {
      this.drawer.addObjectToDm(this);
      this.wasRemoved = false;
    }

    if (this.geometry && sensorObject && sensorObject.active()) {
      let topRow: string = "";
      let bottomRow: string = "";

      if (sensorObject.isAcoustic) {
        topRow = "ID: " + sensorObject.sensorID;
        bottomRow = "Type: " + sensorObject.SensorType;
      }
      else if (sensorObject.isVideo) {
        topRow = "ID: " + sensorObject.sensorID;
        bottomRow = "Type: " + sensorObject.SensorType;
      }
      else {
        topRow = "SIC: " + sensorObject.sic + "  (" + sensorObject.sensorLetter + ")";
        bottomRow = "SAC: " + sensorObject.sac;
      }

      let labelVisible = settings.userSettings.pointElementsOn[consts.POINT_DISPLAY_ELEMENT_LABEL];
      let hook = aspSettings.selectedIds.has(this.id) ? ['hook-circle'] : null;
      this.drawData[this.aspObject.objectType].values = [ // per template
        labelVisible ? ['sensor-db-horiz-leader'] : null, // DB main leader
        [sensorObject.getSymbol(true)], // symbol
        labelVisible ? ['sensor-db-main-bg'] : null, // DB main area
        labelVisible ? topRow : null,
        labelVisible ? bottomRow : null,
        hook
      ];

      let update = false;
      this.color = this.aspObject.getColor();
      this.color[3] = settings.userSettings.pointOpacity;
      this.drawData[this.aspObject.objectType].colors[1] = this.color;

      this.drawer.drawMgr.typesVisualProps.sensorsCluster.globalParams.background.color[3] = settings.userSettings.pointOpacity;
      this.drawer.drawMgr.typesVisualProps.sensorsCluster.globalParams.numbers.color[3] = settings.userSettings.pointOpacity;
      this.drawer.drawMgr.typesVisualProps.sensorsCluster.globalParams.selectedBackground.color[3] = settings.userSettings.pointOpacity;
      this.drawer.drawMgr.typesVisualProps.sensorsCluster.globalParams.selectedNumbers.color[3] = settings.userSettings.pointOpacity;

      let hooked = aspSettings.selectedIds.has(this.id);
      if (this.isHooked != hooked) {
        update = true;
        this.isHooked = hooked
      }
      if (this.opacity != settings.userSettings.pointOpacity) {
        this.opacity = settings.userSettings.pointOpacity;
        update = true;
      }
      if (this.labelVisible != labelVisible) {
        update = true;
        this.labelVisible = labelVisible;
      }
      if (this.dataChanged) {
        update = true;
        this.dataChanged = false;
      }

      if (update) {
        this.drawer.updateObjectInDm(this);
      }
    }
  }

  public wasAdded: boolean = false;
  // Override DisplayObject
  onDataChange(): void {
    super.onDataChange();

    if (!this.isDisplayed && this.geometry != null) {
      this.prepareToDraw();
      if (!this.wasAdded) {
        this.drawer.addObjectToDm(this);
        this.wasAdded = true;
      }
    }

    this.dataChanged = true;
  }

  // Override DisplayObject
  hookedTemplateIndex(): number {
    return 5;
  }

}
